export default __webpack_public_path__ + "static/media/blogImage2.9b1700ef.jpg";